/**
 * Costanti centralizzate per il tema display (proiettore).
 * Dark fantasy: sfondi scuri con accenti caldi/dorati, font fantasy.
 * Riusa nomi fazione dal tema audience.
 */

export { TEAM_FACTION_NAMES, TEAM_SHORT_NAMES } from '../audience/components/teamTheme';

export const DISPLAY_TEAM_BG: Record<string, string> = {
  BLUE: 'display-dark-bg-blue',
  RED: 'display-dark-bg-red',
  GREEN: 'display-dark-bg-green',
  YELLOW: 'display-dark-bg-yellow',
};

// Team borders — bright enough for dark backgrounds
export const DISPLAY_TEAM_BORDER: Record<string, string> = {
  BLUE: 'border-blue-400',
  RED: 'border-red-400',
  GREEN: 'border-green-400',
  YELLOW: 'border-yellow-400',
};

// Team text — light/bright variants for dark background
export const DISPLAY_TEAM_TEXT: Record<string, string> = {
  BLUE: 'text-blue-300',
  RED: 'text-red-300',
  GREEN: 'text-green-300',
  YELLOW: 'text-yellow-300',
};

export const DISPLAY_TEAM_ACCENT: Record<string, string> = {
  BLUE: 'text-blue-400',
  RED: 'text-red-400',
  GREEN: 'text-green-400',
  YELLOW: 'text-yellow-400',
};

export function getDisplayTeamBg(team?: string | null): string {
  if (!team) return 'display-dark-bg';
  return DISPLAY_TEAM_BG[team.toUpperCase()] || 'display-dark-bg';
}

export function getDisplayTeamBorder(team?: string | null): string {
  if (!team) return 'border-parchment-500/40';
  return DISPLAY_TEAM_BORDER[team.toUpperCase()] || 'border-parchment-500/40';
}

export function getDisplayTeamText(team?: string | null): string {
  if (!team) return 'text-parchment-100';
  return DISPLAY_TEAM_TEXT[team.toUpperCase()] || 'text-parchment-100';
}
